import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isValidEmail, showToast } from "../utils/helpers";
import { LoginRequestType } from "../Constants/Interfaces";

import { loginAction } from "../Services/Store/Actions/AuthActions";

const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isLoggedIn } = useSelector((state: any) => state.auth);

  const [data, setData] = useState<LoginRequestType>({
    email: "",
    password: "",
    type: "credentials",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (name: string, value: string) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const validateForm = () => {
    let isError = false;
    const errs = {
      email: "",
      password: "",
    };

    if (!data.email || data.email == "") {
      isError = true;
      errs.email = "Please enter your email";
    } else if (data.email && !isValidEmail(data.email)) {
      isError = true;
      errs.email = "Please enter valid email";
    }

    if (!data.password || data.password == "") {
      isError = true;
      errs.password = "Please enter your password";
    }

    setErrors(errs);

    return isError;
  };

  const submitLogin = async (onSuccess?: Function | null) => {
    const isErr = validateForm();

    if (!isErr) {
      setLoading(true);
      loginAction(data, dispatch)
        .then((res) => {
          const { data } = res;

          if (data && res.type === "success") {
            if (onSuccess) {
              console.log("login success Here...");

              onSuccess();
            }

            showToast("success", data?.message);
          } else {
            showToast("error", data ? data.message : "");
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const logout = async () => {
    if (loading) {
      setLoading(true);

      setLoading(false);
    }
  };

  return {
    user,
    isLoggedIn,
    loading,
    submitLogin,
    data,
    onChange,
    errors,
    logout,
  };
};

export default useAuth;
